import useAppMain from "src/hooks/useAppMain";
import {
  CLIENT_ROUTES,
  CLIENT_TAB_LIST,
  ClientCardBg,
} from "src/utils/constants";
import { useNavigate } from "react-router-dom";
import { Flex, Text, Input, List, Box, useMantineTheme } from "@mantine/core";
import { useContext, useState, useEffect, useCallback } from "react";
import { BiSearch } from "react-icons/bi";
import { AppContext } from "src/api/AppContext";
import { FiMapPin } from "react-icons/fi";
import { GetClientQuery } from "src/generated/graphql";
import {
  defaultEventFilters,
  useScheduleEventContext,
} from "src/api/context/ScheduleEventContext";

export type IChartFilter = {
  locations: string[];
  dateRange?: [Date, Date];
};

function EventLocations() {
  useAppMain(CLIENT_TAB_LIST.SCEDULE_EVENT, true);
  const { currentClient } = useContext(AppContext);
  const navigate = useNavigate();
  const theme = useMantineTheme();
  const [searchedList, setSearchedList] = useState<
    NonNullable<GetClientQuery["clientOne"]>["locations"]
  >([]);
  const { setFilters, searchedLocValue, setSearchedLocValue } =
    useScheduleEventContext();

  useEffect(() => {
    if (searchedLocValue) {
      sendRequestSearch(searchedLocValue);
    } else {
      setSearchedList(currentClient?.locations);
    }
  }, [currentClient?.locations]);

  const handleNav = (id: string) => {
    setFilters({
      ...defaultEventFilters,
      locations: [id],
    });

    navigate("/" + CLIENT_ROUTES.SCHEDULE_TYPE);
  };

  const sendRequestSearch = useCallback((value: string) => {
    if (currentClient?.locations?.length) {
      const filteredLocations = currentClient?.locations.filter((location) => {
        const { id, ...restOfLocation } = location;
        // search on all fields (state, zip, name, address ..)
        const valuesToSearch = Object.values(restOfLocation)
          .join(" ")
          .toLowerCase();
        return valuesToSearch.includes(value.toLowerCase());
      });
      setSearchedList([...filteredLocations]);
    }
  }, []);

  useEffect(() => {
    sendRequestSearch(searchedLocValue);
  }, [searchedLocValue]);

  return (
    <>
      <Text size={18} fw={500} color={theme.colors.secondaryTextColor[6]}>
        Select a location
      </Text>

      <Input
        mt={"sm"}
        icon={<BiSearch color="black" />}
        placeholder="Search location"
        defaultValue={searchedLocValue}
        // value={searchedLocValue}
        onChange={(event) => setSearchedLocValue(event.currentTarget.value)}
        sx={{
          borderColor: "#EBEBEB",
          input: {
            background: "#F6F6F6",
          },
        }}
      />

      <List
        my={10}
        styles={{
          itemWrapper: {
            width: "100%",
          },
          item: {
            listStyle: "none",
            cursor: "pointer",
            borderBottom: `1px solid #DDDDDD`,
          },
        }}
      >
        {searchedList?.map((val) => {
          return (
            <List.Item key={val.id} my={15} py={10}>
              <Flex
                align={"center"}
                gap={"sm"}
                sx={{ cursor: "pointer" }}
                onClick={() => handleNav(val.id)}
              >
                <Flex
                  bg={theme.colors.primary[6]}
                  sx={{
                    borderRadius: 4,
                    width: 40,
                    height: 40,
                  }}
                  align={"center"}
                  justify={"center"}
                >
                  <FiMapPin
                    color={theme.colors.primaryTextColor[6]}
                    size={16}
                  />
                </Flex>

                <Box>
                  <Text size={18} color={theme.colors.secondaryTextColor[6]}>
                    {val.name}
                  </Text>
                  <Text size={12} color={theme.colors.secondaryTextColor[6]}>
                    {`${val.address} ${val.city}, ${val.state} ${val.zip}`}
                  </Text>
                </Box>
              </Flex>
            </List.Item>
          );
        })}
      </List>

      {!searchedList?.length && (
        <Text
          align="center"
          fw={700}
          size={"xl"}
          mt={"xl"}
          color={theme.colors.secondaryTextColor[6]}
        >
          No Location found
        </Text>
      )}
    </>
  );
}

export default EventLocations;
